import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-expandable', 'expandRow', 'Näita rida');
Labels.set('ui-table-expandable', 'collapseRow', 'Peida rida');
Labels.set('ui-table-expandable', 'actions', 'Toimingud');
